<template>
  <b-row>
    <b-col cols="12" v-if="hasPermission('show_branches')">
    
      <b-card>
      <validation-observer ref="simpleForm">
      <form >
      <b-tabs lazy vertical nav-wrapper-class="nav-hidden" align="left" v-model="activeTab">
        <b-tab
    
      >
            <template #title>
              <feather-icon icon="CodepenIcon" />
              <span>Branch Details</span>
            </template>


            <b-row>
              <b-col md="6">
                <b-form-group :label="$t('name')" label-for="vi-name">
                
                    <b-form-input
                    :disabled="true"
                      id="vi-name"
                      type="name"
                      v-model="form.name"
                      placeholder="john.doe@email.com"
                    />
                 
                
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Auditor Email" label-for="vi-email">
                  <validation-provider
                    #default="{ errors }"
                    rules="email"
                    name="email"
                  >
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      id="vi-email"
                      type="email"
                      v-model="form.auditor"
                      placeholder="john.doe@email.com"
                    />
                    <ValidationErrors
                      
                      :frontend-errors="errors"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Supervisor Email" label-for="vi-email">
                  <validation-provider
                    #default="{ errors }"
                    rules="email"
                    name="email"
                  >
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      id="vi-email"
                      type="email"
                      v-model="form.supervisor"
                      placeholder="john.doe@email.com"
                    />
                    <ValidationErrors
                      
                      :frontend-errors="errors"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Financial Email" label-for="vi-email">
                  <validation-provider
                    #default="{ errors }"
                    rules="email"
                    name="email"
                  >
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      id="vi-email"
                      type="email"
                      v-model="form.financial"
                      placeholder="john.doe@email.com"
                    />
                    <ValidationErrors
                      
                      :frontend-errors="errors"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Medical Email" label-for="vi-email">
                  <validation-provider
                    #default="{ errors }"
                    rules="email"
                    name="email"
                  >
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      id="vi-email"
                      type="email"
                      v-model="form.medical"
                      placeholder="john.doe@email.com"
                    />
                    <ValidationErrors
                      
                      :frontend-errors="errors"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Operation Manager Email" label-for="vi-email">
                  <validation-provider
                    #default="{ errors }"
                    rules="email"
                    name="email"
                  >
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      id="vi-email"
                      type="email"
                      v-model="form.manager"
                      placeholder="john.doe@email.com"
                    />
                    <ValidationErrors
                      
                      :frontend-errors="errors"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
         


            </b-row>

         </b-tab>

         <!-- Branch Connections Tab -->
         <b-tab>
            <template #title>
              <feather-icon icon="DatabaseIcon" />
              <span>Branch Connections</span>
            </template>

            <!-- Connections List View -->
            <div v-if="!showConnectionForm">
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h4 class="mb-0">Database Connections</h4>
                    <b-button variant="primary" size="sm" @click="openConnectionModal()">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      Add Connection
                    </b-button>
                  </div>

                  <b-table
                    :items="connections"
                    :fields="connectionFields"
                    responsive
                    striped
                    hover
                    show-empty
                    empty-text="No connections found for this branch."
                    class="mb-0"
                  >
                    <template #cell(host_port)="data">
                      {{ data.item.host }}:{{ data.item.port }}
                    </template>
                    <template #cell(database)="data">
                      {{ data.item.database_name || data.item.service_name }}
                    </template>
                    <template #cell(actions)="data">
                      <b-button variant="flat-info" size="sm" class="mr-50" @click="openConnectionModal(data.item)">
                        <feather-icon icon="EditIcon" />
                      </b-button>
                      <b-button variant="flat-danger" size="sm" @click="removeConnection(data.item.id)">
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </div>

            <!-- Connection Form View -->
            <div v-else>
              <h5 class="mb-2">{{ isEditingConnection ? 'Edit Connection' : 'New Connection' }}</h5>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Connection Name" label-for="conn-name">
                    <b-form-input
                      id="conn-name"
                      v-model="connectionForm.connection_name"
                      placeholder="e.g. oracle49"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Host" label-for="conn-host">
                    <b-form-input
                      id="conn-host"
                      v-model="connectionForm.host"
                      placeholder="e.g. 192.168.1.100"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Port" label-for="conn-port">
                    <b-form-input
                      id="conn-port"
                      v-model="connectionForm.port"
                      placeholder="1521"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Service Name (Oracle)" label-for="conn-service">
                    <b-form-input
                      id="conn-service"
                      v-model="connectionForm.service_name"
                      placeholder="Optional"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Database Name" label-for="conn-database">
                    <b-form-input
                      id="conn-database"
                      v-model="connectionForm.database_name"
                      placeholder="Enter database name"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Username" label-for="conn-username">
                    <b-form-input
                      id="conn-username"
                      v-model="connectionForm.username"
                      placeholder="Enter username"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="isEditingConnection ? 'Password (leave blank to keep current)' : 'Password'"
                    label-for="conn-password"
                  >
                    <b-form-input
                      id="conn-password"
                      type="password"
                      v-model="connectionForm.password"
                      placeholder="Enter password"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="mt-1 mb-2">
                <b-button class="btn btn-info mr-2" @click="saveConnection">
                  {{ isEditingConnection ? 'Update' : 'Save' }}
                </b-button>
                <b-button @click="closeConnectionForm">
                  Cancel
                </b-button>
              </div>
            </div>

         </b-tab>

      </b-tabs>
      </form>
           </validation-observer>
    </b-card>
    <b-row class="mb-5 " v-if="activeTab === 0">
      <div class="ml-5  w-100">
      
          <b-button class="btn btn-info mr-2" @click="save">
            Save
          </b-button>
        
       

        <router-link :to="`/branches`">
          <b-button class="mr-5"> Cancel </b-button>
        </router-link>

      </div>
    </b-row>
    </b-col>
  </b-row>
</template>

<script>
import show from "@/views/cases/components/show";

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Multiselect from "vue-multiselect";
import { required, email, digits, length } from "@validations";
import {
  BRow,
  BCol,
  BTab,
  BTabs,
  BOverlay,
  BCard,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormTag,
  BFormTags,
  BFormTextarea,
  BTable,
  BModal,
  BForm,
  BButton,
} from "bootstrap-vue";
import { localize, ValidationObserver, ValidationProvider } from "vee-validate";
import ValidationErrors from "@/views/components/common/ValidationErrors";
import { mapActions, mapGetters } from "vuex";


export default {
  components: {
    FormWizard,
    BOverlay,
    TabContent,
    BRow,
    BTab,
    BTabs,
    BFormTag,
    BFormTags,
    BFormDatepicker,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    vSelect,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    localize,
    Multiselect,
    ValidationErrors,
    BTable,
    BModal,
    BForm,
    BButton,
  },
  computed: {
    ...mapGetters({
      lookups: "app/lookups",
      user: "branches/item",
   //   roless: "roles/roles",
      load: "branches/load",
    //  userRoles: "roles/userRoles",
    }),

    id() {
      return this.$route.params && this.$route.params.id
        ? this.$route.params.id
        : null;
    },
  
 
  },
 
  data() {
    return {
      branches: [],
      //  roless:[],
      user_roles: [],
      errors_data: {},
      errorsdata: {},
      academic_info: false,
      address: false,
      contact: false,
      form: {},
      activeTab: 0,
      query: {
        ranks: true,
        faculties: true,
        employee_types: true,
        faculty_departments: true,
      },
      // Branch Connections
      connections: [],
      showConnectionForm: false,
      isEditingConnection: false,
      connectionForm: {
        id: null,
        branch_id: null,
        connection_name: '',
        driver: 'oracle',
        host: '',
        port: '1521',
        database_name: '',
        service_name: '',
        username: '',
        password: '',
      },
      connectionFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'connection_name', label: 'Connection Name', sortable: true },
        { key: 'host_port', label: 'Host' },
        { key: 'database', label: 'Database / Service' },
        { key: 'username', label: 'Username' },
        { key: 'actions', label: 'Actions', class: 'text-center' },
      ],
    };
  },

  mounted() {
    this.init();
    this.fetchConnections();
  },

  methods: {
    ...mapActions({
      // getLookups: 'app/GET_LOOKUPS',
      saveUser: "branches/put",
    }),
 

    validateAsync: function (index) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.$refs.simpleForm.validate().then((success) => {
            if (success) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }, 1000);
      });
    },

    init() {
     
      if (this.id) {
        this.$store.dispatch("branches/get", this.id).then((_) => {
          if (this.user) {
         
            this.form = this.user;
         
            console.log("frmmmmm",this.form);
            
      
          }
        });
      }
      let query = {};
      // this.$store.dispatch("branches/branches", { query }).then((res) => {
      //   this.branches = res;
      // });

      // this.$store.dispatch("roles/getRoles").then((res) => {
      //   //  this.roless=res;
      //   //  console.log(this.roless);
      // });

    
    },

    back() {
      this.$router.push({
        name: "branches",
      });
    },
    save() {
   
      this.$refs.simpleForm.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch("branches/put", { id: this.id, query: this.form })
            .then((res) => {

              if (res == 'error')
              {
                  this.$swal({
                            icon: "error",
                            title: 'This Email does already exist',
                            showConfirmButton: false,
                            timer: 2000,
                          });

                          // this.$router.push({
                          //   name: "users",
                          // });
              }
              else {

                    this.$swal({
                      icon: "success",
                      title: this.$t("Global.Saved"),
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.$router.push({
                      name: "branches",
                    });
              }
  
            })
            .catch((error) => {
              this.errorsdata = this.handleBackendError(
                error.response.data.errors
              );

              console.log(this.errors_data);
            });
       }
      });
    },

    // ── Branch Connections ──────────────────────────────
    // async fetchConnections() {
    //   if (!this.id) return;
    //   try {
    //     const res = await this.$store.dispatch('branches/getConnections', this.id);
    //     this.connections = res.data || res || [];
    //   } catch (error) {
    //     console.error('Error fetching connections', error);
    //   }
    // },

    openConnectionModal(conn = null) {
      if (conn) {
        this.isEditingConnection = true;
        this.connectionForm = { ...conn, password: '' };
      } else {
        this.isEditingConnection = false;
        this.resetConnectionForm();
      }
      this.connectionForm.branch_id = this.id;
      this.showConnectionForm = true;
    },

    resetConnectionForm() {
      this.connectionForm = {
        id: null,
        branch_id: this.id,
        connection_name: '',
        driver: 'oracle',
        host: '',
        port: '1521',
        database_name: '',
        service_name: '',
        username: '',
        password: '',
      };
      this.isEditingConnection = false;
    },

    async saveConnection() {
      try {
        if (this.isEditingConnection) {
          await this.$store.dispatch('branches/updateConnection', {
            id: this.connectionForm.id,
            data: this.connectionForm,
          });
        } else {
          await this.$store.dispatch('branches/storeConnection', this.connectionForm);
        }
        this.showConnectionForm = false;
        this.fetchConnections();
        this.$swal({
          icon: 'success',
          title: 'Connection saved successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error('Error saving connection', error);
        this.$swal({
          icon: 'error',
          title: 'Failed to save connection',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },

    async removeConnection(id) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'This connection will be permanently deleted.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ml-1',
        },
        buttonsStyling: false,
      });
      if (result.value) {
        try {
          await this.$store.dispatch('branches/deleteConnection', id);
          this.fetchConnections();
          this.$swal({
            icon: 'success',
            title: 'Connection deleted',
            showConfirmButton: false,
            timer: 1500,
          });
        } catch (error) {
          console.error('Error deleting connection', error);
        }
      }
    },

    closeConnectionForm() {
      this.showConnectionForm = false;
      this.resetConnectionForm();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.wizard-btn,
.wizard-icon-container {
  background-color: #054978 !important;
  border-color: #054978 !important;
}

.stepTitle.active {
  color: #054978 !important;
}
</style>

